export default __webpack_public_path__ + "images/SpeakersPhotos/Javier_Martin_Integrarobot.jpg?22c5afac";